export default __webpack_public_path__ + "static/media/introduction_kr.039b6d3b.png";